import { observer } from 'mobx-react-lite'
import { type FC, useState } from 'react'
import { MenuItem, MenuTitle, SpinnerLoader, Tooltip, Typography } from 'shared/ui'
import { type CallHistoryFiltersStore } from 'pages/conversations/pages/calls/ui/CallHistoryFilters/store/CallHistoryFiltersStore'
import { type CallFilter } from 'pages/conversations/pages/calls/ui/CallHistoryFilters/store/CallFilter'
import styles from './styles.module.scss'

type ICallHistoryFiltersListProps = {
  store: CallHistoryFiltersStore
}

export const CallHistoryFiltersList: FC<ICallHistoryFiltersListProps> = observer(({ store }) => {
  const [isShowInboundFilters, setIsShowInboundFilters] = useState<boolean>(true)
  const [isShowOutboundFilters, setIsShowOutboundFilters] = useState<boolean>(true)
  const {
    loading,
    hasCalls,
    allCallsFilter,
    setActiveFilter,
    activeFilterKey,
    inboundFilters,
    outboundFilters,
  } = store

  const getMenuitem = (filter: CallFilter) => {
    return (
      <Tooltip label={filter.info.tooltip} placement={'right'} fullWidth>
        <MenuItem
          key={filter.info.title}
          type={'default'}
          label={filter.info.title}
          icon={filter.info.icon}
          iconColor={filter.info.iconColor}
          fontSize={filter.info.fontSize}
          active={filter.id === activeFilterKey}
          variantActiveState={'blue'}
          count={filter.unreadCount}
          onClick={() => {
            setActiveFilter(filter.id)
          }}
        />
      </Tooltip>
    )
  }

  return (
    <div className={styles.callsFiltersInfo}>
      {loading && (
        <div className={styles.listStatus}>
          <SpinnerLoader ariaLabel={'CallHistoryFiltersList'} />
        </div>
      )}

      {!loading && hasCalls && (
        <>
          {allCallsFilter && (
            <div className={styles.filterGroup}>{getMenuitem(allCallsFilter)}</div>
          )}
          <div className={styles.filterGroup}>
            <MenuTitle
              title={'Inbound'}
              open={isShowInboundFilters}
              handleToggle={() => setIsShowInboundFilters(!isShowInboundFilters)}
            />
            {isShowInboundFilters && (
              <ul className={styles.filters}>
                {inboundFilters.map((filter) => (
                  <li key={filter.id}>{getMenuitem(filter)}</li>
                ))}
              </ul>
            )}
          </div>
          <div className={styles.filterGroup}>
            <MenuTitle
              title={'Outbound'}
              open={isShowOutboundFilters}
              handleToggle={() => setIsShowOutboundFilters(!isShowOutboundFilters)}
            />
            {isShowOutboundFilters && (
              <ul className={styles.filters}>
                {outboundFilters.map((filter) => (
                  <li key={filter.id}>{getMenuitem(filter)}</li>
                ))}
              </ul>
            )}
          </div>
        </>
      )}

      {!loading && !hasCalls && (
        <div className={styles.emptyCalls}>
          <Typography variant={'body-rg-medium'} ariaLabel={'NoCalls'}>
            No calls
          </Typography>
        </div>
      )}
    </div>
  )
})
